// src/hooks/useAuth.js
// AuthContext ile birleştirildi - geriye dönük uyumluluk için yönlendirme
import { useAuth } from '../context/AuthContext'

const useAuthHook = () => useAuth()

export default useAuthHook
